import { FailedCheckDetails, PxQualifications } from "../types/apis";

export const parseFailedChecks = (
  failedChecks: FailedCheckDetails[],
): PxQualifications => {
  const initialValue: PxQualifications = {};
  return failedChecks.reduce((qualifications, failedCheck) => {
    switch (failedCheck.key) {
      case "IMPORTED":
        qualifications.import = true;
        break;
      case "MILEAGE_DISCREPANCY":
        qualifications.mileage_incorrect = true;
        break;
      case "INSURANCE_WRITE_OFF":
        qualifications.total_loss = true;
        break;
    }
    return qualifications;
  }, initialValue);
};
